// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9442c416","667":"c2d5a3d9","867":"8f05c8a0"}[chunkId] + ".chunk.js";
};